import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'arraytostring'
})
export class ArraytostringPipe implements PipeTransform {

  transform(value:any, ...args: unknown[]): unknown {

      if(Array.isArray(value)){
        if(value.length > 0){
          value[0].replace(",","<br>");
        }else{
          value = "-";
        }
         
      }
    return value;
  }

}
